import request from './core/request'

// 商品相关API
export default {
	//获取商品分类
	getGoodsCategory: (parentId) => request.get(`/goods/category/get/${parentId}`, {}, {
		needAccessToken: false,
	}),
	//从ES中获取商品信息（用于首页）
	getGoodsList: (params) => request.get('/goods/goods/es', params, {
		needAccessToken: false,
	}),
	//获取商家商品信息
	getStoreGoodsList: (params) => request.get('/goods/goods', params, {
		needAccessToken: false,
	}),
	//获取商品详情
	getGoodsDetail: (goodsId, params) => request.get(`/goods/goods/get/${goodsId}`, params, {
		needAccessToken: false,
	}),
	//获取商品列表（根据上传图片搜索）
	getGoodsByImage: (data) => request.post('/goods/imageSearch/search', data, {})
}